import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CoverageMap } from './CoverageMap';
import { Counter } from './Counter';
export function Coverage() {
  return <section id="coverage" className="w-full bg-ink-900 py-24 lg:py-32" data-id="element-127" data-mp="if2cd4p3dpad">
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10" data-id="element-128" data-mp="do2gm2rpld9g">
        <div className="grid gap-14 lg:grid-cols-[0.85fr_1.15fr] lg:items-center lg:gap-16" data-id="element-129" data-mp="dmiw1zz0sg1v">
          <div data-id="element-130" data-mp="sbf5o1gq614l">
            <Reveal data-id="element-131" data-mp="sf2zz2tzurkd">
              <p className="flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.24em] text-ice-400" data-id="element-132" data-mp="ndvpux4dpgaj">
                <span className="h-px w-8 bg-ice-400" aria-hidden="true" data-id="element-133" data-mp="11e6hi2diiywr" />
                Nationwide Coverage
              </p>
              <h2 className="mt-6 font-display text-3xl font-extrabold leading-[1.05] tracking-tightest text-white sm:text-4xl lg:text-[3.1rem]" data-id="element-134" data-mp="wfv9lx6s2yh6">
                From Coast to Coast.
              </h2>
              <p className="mt-8 max-w-lg text-base leading-relaxed text-white/65" data-id="element-135" data-mp="2y78a8a1pqk7f">
                Based in Davenport, Florida and operating throughout the continental United States, Hold Fast Hauling
                provides reliable transportation across major freight corridors, ports, distribution centers, and
                agricultural regions.
              </p>
            </Reveal>

            <Reveal delay={0.05} data-id="element-136" data-mp="pjsaexh9r2c">
              <div className="mt-10 flex flex-wrap items-end gap-10 border-t border-white/15 pt-8" data-id="element-137" data-mp="quwgfuu50tz">
                <p className="font-display text-5xl font-extrabold tracking-tightest text-white lg:text-6xl" data-id="element-138" data-mp="4sg6zujwd310">
                  <Counter target={48} data-id="element-139" data-mp="eojgxmkzq5yi" />
                  <span className="ml-2 align-middle text-[11px] font-bold uppercase tracking-[0.18em] text-ice-400" data-id="element-140" data-mp="epkrzr20asg8">
                    State Coverage
                  </span>
                </p>
              </div>
              <a href="#contact" className="group mt-10 inline-flex items-center gap-2 rounded-full border border-white/30 px-7 py-3.5 text-[12px] font-bold uppercase tracking-[0.1em] text-white transition-colors duration-150 ease-premium hover:border-white hover:bg-white/5" data-id="element-141" data-mp="2gh7k5vxmwtea">
                Check Your Lane
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-premium group-hover:translate-x-1" data-id="element-142" data-mp="2nc7lljelacml" />
              </a>
            </Reveal>
          </div>

          <Reveal delay={0.1} data-id="element-143" data-mp="2ifqseasj982n">
            <CoverageMap data-id="element-144" data-mp="2wcdsunjp2gdb" />
          </Reveal>
        </div>
      </div>
    </section>;
}